import { nextTick, ref } from 'vue'

export const actionMenuMixin = () => {
  const showMenu = ref(false)
  const selectedItem = ref(null)
  const x = ref(0)
  const y = ref(0)

  const show = async (event: MouseEvent, item: any = null) => {
    selectedItem.value = item
    event.preventDefault()
    showMenu.value = false
    x.value = event.clientX
    y.value = event.clientY
    await nextTick()
    showMenu.value = true
  }
  return { x, y, showMenu, selectedItem, show }
}
